export default __webpack_public_path__ + "static/media/section1.31eb87ba.jpg";